export enum Roles {
  Admin = 'admin',
  InvoiceEditor = 'invoice_editor',
  EsgOperator = 'esg_operator',
  IndexOperator = 'index_operator',
  Operator = 'operator',
  MarketingOperator = 'marketing_operator'
}

export enum Categories {
  Comminications = 'Communications',
  Research = 'Research'
}
